// extracted by mini-css-extract-plugin
export default {"switch":"checkbox_switch__jyS3H","slider":"checkbox_slider__VPV-W"};